import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';
import axios from 'axios';

export default class OrganizationLogoResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  uploadMeta(file) {
    const { name, type } = file;
    const urlParams = objectToUrlParams({ name, content_type: type });
    return super
      .post({}, { url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  uploadFile(url, file) {
    return axios
      .put(url, file, {
        headers: {
          'x-ms-blob-type': 'BlockBlob',
          'Content-Type': file.type,
        },
      })
      .then((response) => response)
      .catch((error) => error.response);
  }

  remove() {
    return super
      .delete()
      .then((response) => response)
      .catch((error) => error.response);
  }
}
